import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//分页查询人才绿卡
export const GetTalenGreenCardByPage = (data) => {
  return axios.post(
    `${base}/api/TalentGreenCard/GetTalenGreenCardByPage`,
    data
  );
};

//分页查询人才绿卡
export const UpdateTalentgreencardState = (params) => {
  return axios.get(`${base}/api/TalentGreenCard/UpdateTalentgreencardState`, {
    params: params,
  });
};
